'use client';
import { SvgStar } from '@bazaar-marketplace/assets/star';
import { SvgSticker } from '@bazaar-marketplace/assets/sticker';
import { SvgTrendUp } from '@bazaar-marketplace/assets/trend-up';
import { SvgShoppingBag } from '@bazaar-marketplace/assets/shopping-bag';
import { useTranslations } from 'next-intl';

import { ROUTES } from '~/constants';

import type { NavigationItemProps } from './navigation-item';
import { useState } from 'react';
import { SvgStars03 } from '@bazaar-marketplace/assets/stars-03';
import { usePathname } from 'next/navigation';

export const useNavigationConfig = (): {
  routes: NavigationItemProps[];
  marketSheetOpen: boolean;
  setMarketSheetOpen: (open: boolean) => void;
  isVisible: boolean;
} => {
  const t = useTranslations('navigation');
  const pathname = usePathname();
  const [marketSheetOpen, setMarketSheetOpen] = useState(false);

  const hiddenNavigationRoutes = [
    ROUTES.WORKSHOP_BURNING,
    ROUTES.WORKSHOP_BURNING_DETAIL(''),
    ROUTES.WORKSHOP_STAKING,
    ROUTES.WORKSHOP_STAKING_DETAIL(''),
  ];

  const isVisible = !hiddenNavigationRoutes.some((route) => pathname === route || pathname.startsWith(`${route}/`));

  const routes = [
    {
      href: ROUTES.STICKERS,
      text: t('stickers'),
      icon: <SvgSticker />,
      disabled: false,
    },
    {
      href: ROUTES.MARKET,
      text: t('market'),
      icon: <SvgShoppingBag />,
      disabled: false,
      onClick: () => {
        setMarketSheetOpen(true);
      },
    },
    {
      href: ROUTES.EARN,
      text: t('earn'),
      icon: <SvgTrendUp />,
      disabled: false,
    },
    {
      href: ROUTES.MY_COLLECTIONS,
      text: t('my-collections'),
      icon: <SvgStar />,
      disabled: false,
    },
    {
      href: ROUTES.WORKSHOP,
      text: t('workshop'),
      icon: <SvgStars03 className="size-5" />,
      disabled: false,
    },
  ];

  return {
    routes,
    marketSheetOpen,
    setMarketSheetOpen,
    isVisible,
  };
};
